import { render } from "./NumberDecoderDocumentation.vue?vue&type=template&id=a381b6ea"
const script = {}

import exportComponent from "/home/krists/Documents/git/bomb-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__